module.exports = __webpack_public_path__ + "static/img-slide-2-es-a25011b2025bb5dad7bca2320bf477e9.png";